export const colors = {
    purple: "#bf00ff",
    brown: "#c9b18aff",
    red: "#d13328",
    lightRed: "#c76861",
    lightBlue: "#347e8aff",
    darkBlue: "#29576eff",
    gray: "#5b778fff",
    lightGray: "#F3F5F7",
    green: "#7DDE92",
    lightGreen: "#b2d9ba",
};

export const textSizes = {
    t0: "48px",
    t1: "36px",
    t2: "26px",
    t3: "22px",
    t4: "18px",
    t5: "16px",
    t6: "14px",
};

const theme = {
    ...colors,
    textSizes,
};

export default theme;
